export const formatFontFamilyName = (s: string) => {
  const indexOfParen = s.indexOf(' (');
  if (indexOfParen > -1) {
    return s.substring(0, indexOfParen);
  }
  return s;
};
